import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminDashboardComponent } from '../admin-dashboard/admin-dashboard.component';

import { AdminPage } from './admin.page';

const routes: Routes = [
  {
    path: '',
    component: AdminPage,
    children: [
      {
        path: '',
        component: AdminDashboardComponent,
      },
      {
        path: 'users',
        loadChildren: () =>
          import('../users/users.module').then((m) => m.UsersPageModule),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('../products/products.module').then(
            (m) => m.ProductsPageModule
          ),
      },
      {
        path: 'galeries',
        loadChildren: () =>
          import('../catalogue/catalogue.module').then(
            (m) => m.CataloguePageModule
          ),
      },
      {
        path: 'paylist',
        loadChildren: () =>
          import('../pedidos-y-pagos/methods.module').then(
            (m) => m.MethodsPageModule
          ),
      },
      {
        path: 'currencies',
        loadChildren: () =>
          import('../currencies/currencies.module').then(
            (m) => m.CurrenciesPageModule
          ),
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('../categories/categories.module').then(
            (m) => m.CategoriesPageModule
          ),
      },
      {
        path: 'gains',
        loadChildren: () =>
          import('../payments/payments.module').then(
            (m) => m.PaymentsPageModule
          ),
      },
      {
        path: 'banner',
        loadChildren: () =>
          import('../banner/banner.module').then((m) => m.BannerPageModule),
      },
      {
        path: 'sponsor',
        loadChildren: () =>
          import('../sponsor/sponsor.module').then((m) => m.SponsorPageModule),
      },
      {
        path: 'terms',
        loadChildren: () =>
          import('../terms/terms.module').then((m) => m.TermsPageModule),
      },
      {
        path: 'methods',
        loadChildren: () =>
          import('../methods-type/methods-type.module').then(
            (m) => m.MethodsTypePageModule
          ),
      },
      {
        path: 'catalogues',
        loadChildren: () =>
          import('../catalogues/catalogues.module').then(
            (m) => m.CataloguesPageModule
          ),
      },
      {
        path: 'ads',
        loadChildren: () =>
          import('../ads/ads.module').then((m) => m.AdsPageModule),
      },
      {
        path: 'contacts',
        loadChildren: () =>
          import('../contacts/contacts.module').then(
            (m) => m.ContactsPageModule
          ),
      },
      {
        path: 'branch',
        loadChildren: () =>
          import('../contacts-branch/contacts-branch.module').then(
            (m) => m.ContactsBranchPageModule
          ),
      },
      {
        path: 'load',
        loadChildren: () =>
          import('../load/load.module').then((m) => m.LoadPageModule),
      },
      {
        path: 'meeting',
        loadChildren: () =>
          import('../meeting/meeting.module').then((m) => m.MeetingPageModule),
      },
      {
        path: 'gift-card',
        loadChildren: () =>
          import('../gift-card/gift-card.module').then(
            (m) => m.GiftCardPageModule
          ),
      },
      {
        path: 'subscriptions',
        loadChildren: () =>
          import('../subscriptions/subscriptions.module').then(
            (m) => m.SubscriptionsPageModule
          ),
      },
      {
        path: 'attention-schedule',
        loadChildren: () =>
          import('../attention-schedule/attention-schedule.module').then(
            (m) => m.AttentionSchedulePageModule
          ),
      },
      {
        path: 'group',
        loadChildren: () =>
          import('../group/group.module').then((m) => m.GroupPageModule),
      },
      {
        path: 'special-requests',
        loadChildren: () =>
          import('../special-requests/special-requests.module').then(
            (m) => m.SpecialRequestsPageModule
          ),
      },
      {
        path: 'payment-proof',
        loadChildren: () =>
          import('../payment-proof/payment-proof.module').then(
            (m) => m.PaymentProofPageModule
          ),
      },
      {
        path: 'mail-view',
        loadChildren: () =>
          import('../mail-view/mail-view.module').then(
            (m) => m.MailViewPageModule
          ),
      },
      {
        path: 'disccount-per-users',
        loadChildren: () =>
          import('../disccount-per-users/disccount-per-users.module').then(
            (m) => m.DisccountPerUsersPageModule
          ),
      },
      {
        path: 'suggestions-chat',
        loadChildren: () =>
          import('../suggestions-chat/suggestions-chat.module').then(
            (m) => m.SuggestionsChatPageModule
          ),
      },
      {
        path: 'languages',
        loadChildren: () =>
          import('../languages/languages.module').then(
            (m) => m.LanguagesPageModule
          ),
      },
      {
        path: 'virtual-class',
        loadChildren: () =>
          import('../virtual-class/virtual-class.module').then(
            (m) => m.VirtualClassPageModule
          ),
      },
      {
        path: 'wallet-cash-out',
        loadChildren: () =>
          import('../wallet-cash-out/wallet-cash-out.module').then(
            (m) => m.WalletCashOutPageModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminPageRoutingModule {}
